
class CustomSelect {
    constructor() {
        
       

    }

    
}



export { CustomSelect };